import React from "react";

/* ============================================================================
   SegmentedControl — clean editorial-style segmented toggle
   ----------------------------------------------------------------------------
   Drop-in replacement for arrays of pill buttons. Single bar with divided
   cells, active state filled, no spacing between options.

       <SegmentedControl
           value={tab}
           onChange={setTab}
           label="Show"
           options={[{value:'open', label:'Open'}, ...]}
           testid="leads-status-filter"
       />
   ========================================================================== */
export function SegmentedControl({ value, onChange, options, label, testid, size = "md", className = "" }) {
    const heightCls = size === "sm" ? "h-7 text-[11px]" : "h-9 text-xs";
    return (
        <div className={`inline-flex items-center gap-2 ${className}`}>
            {label && (
                <span className="text-[10px] font-bold tracking-[0.18em] uppercase text-muted-foreground">
                    {label}
                </span>
            )}
            <div
                className={`inline-flex items-stretch rounded-full border border-border bg-secondary/30 overflow-hidden ${heightCls}`}
                role="tablist"
                data-testid={testid}
            >
                {options.map((opt) => {
                    const on = value === opt.value;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            role="tab"
                            aria-selected={on}
                            onClick={() => onChange(opt.value)}
                            className={`px-3 font-semibold whitespace-nowrap transition-all border-r border-border last:border-r-0 inline-flex items-center gap-1 ${
                                on
                                    ? "bg-foreground text-white"
                                    : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                            }`}
                            data-testid={testid ? `${testid}-${opt.value}` : undefined}
                        >
                            {opt.dot != null && (
                                <span
                                    className={`w-1.5 h-1.5 rounded-full ${opt.dot}`}
                                    aria-hidden="true"
                                />
                            )}
                            {opt.label}
                            {opt.count != null && (
                                <span className={`ml-1 tabular-nums ${on ? "opacity-80" : "opacity-60"}`}>
                                    {opt.count}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default SegmentedControl;
